export default __webpack_public_path__ + "static/media/logo.7da8af2d.svg";